import { useTranslation, withTranslation } from 'react-i18next';
import {
  Typography,
  Box,
  InputLabel,
  Input,
  FormControl,
} from '@material-ui/core';
import compose from 'ramda/src/compose';
import LocaleKeys from '../../../../../locales/keys';
import { makeStyles } from '@material-ui/core/styles';
import fieldLengths from '../../../../../utils/fieldLengths';

const useStyles = makeStyles((theme) => ({
  'field__input--error': {
    borderColor: theme.palette.error.main,
    borderWidth: '2px',
  },
  firstNameField: {
    '&.MuiInputBase-root': {
      '&.Mui-focused': {
        boxShadow: '0 0 10px #9ecaed',
      },
    },
    fontSize: '15px',
    color: theme.palette.custom?.lightBlack,
  },
  errorMessage: {
    fontFamily: 'Formula1-Regular',
    fontSize: '12px',
    letterSpacing: '.5px',
    fontWeight: 500,
  },
}));

function FirstNameField(props) {
  const {
    form = {},
    name,
    autoFocusRef,
    customClasses,
    resetFormStatus = false,
    resetFormHandler,
  } = props;
  const { values = {} } = form;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={`form-group field field--${name}`}>
      <InputLabel>
        <Typography
          variant="body1"
          color="textPrimary"
          className={customClasses && customClasses.titilliumFont}
        >
          {t(LocaleKeys.registration.firstName)}
        </Typography>
      </InputLabel>
      <FormControl
        className={`field__form-control ${
          customClasses && customClasses.fieldHeight
        }`}
      >
        <Input
          data-cy="field__input"
          className={`field__input ${classes.firstNameField} ${
            form?.errors?.[name] ? classes['field__input--error'] : ''
          }`}
          disableUnderline
          placeholder={t(LocaleKeys.registration.firstName)}
          fullWidth
          name={name}
          onChange={(e) => {
            if (resetFormStatus) {
              resetFormHandler();
            }
            form.handleChange(e);
          }}
          value={values[name] || ''}
          inputRef={(input) => {
            autoFocusRef && (autoFocusRef.current = input);
          }}
          inputProps={{ maxLength: fieldLengths.firstName }}
        />
      </FormControl>
      {form?.errors?.[name] ? (
        <Box ml={3} mt={2} className={`field__errorBox`}>
          <Typography
            variant="body2"
            color="error"
            className={classes.errorMessage}
          >
            {form.errors[name]}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

export default compose(withTranslation())(FirstNameField);
